import {DragHandle} from '@wandb/weave/common/containers/DragDropContainer';
// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components/Button';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import * as PanelTypes from '../../../state/views/panel/types';

export const PanelDragHandle = ({panelRef}: {panelRef: PanelTypes.Ref}) => {
  return (
    <DragHandle
      key={`draghandle-${panelRef.id}`}
      className={twMerge(
        // this determines the mouse grab area. we need to account for the padding around panels and panel actions
        'absolute left-0 right-0 mx-8'
      )}
      partRef={panelRef}>
      <Button
        aria-label="Drag panel"
        className="absolute left-0 top-0 m-0 cursor-grab active:cursor-grabbing"
        icon="drag-grip"
        size="small"
        variant="ghost"
      />
    </DragHandle>
  );
};
